const arrayList = {
  bindings: {
    title: '@',
    items: '<'
  },
  templateUrl:
    '/modules/pis-tool/common/array-list/array-list.html',
  controller: 'ArrayListController',
};

angular
  .module('pis-common.module')
  .component('arrayList', arrayList);
